import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import Loading from "./Loading";

const ProtectedRoute = ({ component: Component, requiredRole, ...rest }) => {
  const { user, isLoading } = useAuth0();

  if (isLoading) {
    return <Loading />;
  }

  // get roles from Auth0 user metadata
  const userRoles = user?.[process.env.REACT_APP_AUTH0_ROLE_PATH] || [];
  const hasRole = requiredRole ? userRoles.includes(requiredRole) : true;

  return (
    <Route
      {...rest}
      render={(props) =>
        user && hasRole ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default ProtectedRoute;
